import { gql } from '@apollo/client';
export const CREATE_MULTISTEP_USER_TEST = gql `
  mutation CreateMultistepUserTest($input: CreateMultistepUserTestInput!) {
    createMultistepUserTest(input: $input) {
      ok
      error {
        message
        code
      }
      project: userTest {
        pk
        prototype {
          visibility
        }
      }
    }
  }
`;
export const CREATE_MULTISTEP_USER_TEST_WITH_DOCUMENT = gql `
  mutation CreateMultistepUserTest(
    $name: String!
    $uuid: String!
    $document: JSONString!
    $visibility: MultistepUsertestVisibilityEnum
  ) {
    createMultistepUserTest(
      input: { name: $name, uuid: $uuid, visibility: $visibility }
    ) {
      ok
      error {
        message
        code
      }
      project: userTest {
        pk
        prototype {
          visibility
        }
      }
    }
    createOrUpdateBuilderJsonObject(
      input: { testUUID: $uuid, document: $document }
    ) {
      ok
      error {
        message
        code
      }
    }
  }
`;
